import { render, staticRenderFns } from "./SubNotPossibleOverlay.vue?vue&type=template&id=a675c2a8&scoped=true"
import script from "./SubNotPossibleOverlay.vue?vue&type=script&lang=js"
export * from "./SubNotPossibleOverlay.vue?vue&type=script&lang=js"
import style0 from "./SubNotPossibleOverlay.vue?vue&type=style&index=0&id=a675c2a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a675c2a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a675c2a8')) {
      api.createRecord('a675c2a8', component.options)
    } else {
      api.reload('a675c2a8', component.options)
    }
    module.hot.accept("./SubNotPossibleOverlay.vue?vue&type=template&id=a675c2a8&scoped=true", function () {
      api.rerender('a675c2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubNotPossibleOverlay.vue"
export default component.exports